import { render, staticRenderFns } from "./ChartVerticalAmountTeam.vue?vue&type=template&id=5ecbdc8a&"
import script from "./ChartVerticalAmountTeam.vue?vue&type=script&lang=js&"
export * from "./ChartVerticalAmountTeam.vue?vue&type=script&lang=js&"
import style0 from "./ChartVerticalAmountTeam.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports